// extracted by css-extract-rspack-plugin
export default {"playground":"playground_whuD","noPadding":"noPadding_tWI2"};